import { GarageInfoDto } from "@1games-ru/region-shared/dist/types/garage/garage";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKey } from "@/domains/transportWarehouse/constants/queryKey";

export default function useTransportWarehouseCacheData() {
  const queryClient = useQueryClient();

  const transportWarehouseInfo = queryClient.getQueryData<GarageInfoDto | null>([
    QueryKey.TransportWarehouseInfo,
  ]);

  return {
    transportWarehouseInfo,
  };
}
